import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaSectionDefaultVariants = {}
const aromaSectionCompoundVariants = []

const aromaSectionSlotNames = [
  [
    "root",
    "aroma-section__root"
  ],
  [
    "title",
    "aroma-section__title"
  ],
  [
    "container",
    "aroma-section__container"
  ],
  [
    "content",
    "aroma-section__content"
  ],
  [
    "footer",
    "aroma-section__footer"
  ]
]
const aromaSectionSlotFns = /* @__PURE__ */ aromaSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaSectionDefaultVariants, getSlotCompoundVariant(aromaSectionCompoundVariants, slotName))])

const aromaSectionFn = memo((props = {}) => {
  return Object.fromEntries(aromaSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaSectionVariantKeys = [
  "withFooter",
  "titleAsContent"
]
const getVariantProps = (variants) => ({ ...aromaSectionDefaultVariants, ...compact(variants) })

export const aromaSection = /* @__PURE__ */ Object.assign(aromaSectionFn, {
  __recipe__: false,
  __name__: 'aromaSection',
  raw: (props) => props,
  variantKeys: aromaSectionVariantKeys,
  variantMap: {
  "withFooter": [
    "true"
  ],
  "titleAsContent": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, aromaSectionVariantKeys)
  },
  getVariantProps
})